import { render, staticRenderFns } from "./videoCourse.vue?vue&type=template&id=4b24faae&scoped=true&"
import script from "./videoCourse.vue?vue&type=script&lang=js&"
export * from "./videoCourse.vue?vue&type=script&lang=js&"
import style0 from "./videoCourse.vue?vue&type=style&index=0&id=4b24faae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b24faae",
  null
  
)

export default component.exports